// FLAGS: none
// The loading state both route guards render while the profile query is still pending.
import Spinner from "@openup/shared/components/Spinner/Spinner";

const FullPageSpinner = () => (
  <div
    className="flex min-h-screen items-center justify-center"
    role="status"
    aria-label="Loading"
  >
    <Spinner />
  </div>
);

export default FullPageSpinner;
